var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 202,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#030302",
    d: "M112 202c-29-2-56-6-82-18-10-5-20-11-24-23-3-9-1-18 4-27v-2C-3 98-3 65 16 32A64 64 0 0 1 91 5c4 2 8-1 12-2 21-5 42-4 60 11 15 13 23 30 28 49 2 8 6 16 7 25 2 10 2 20 0 30v1c3 4 5 9 6 13l2 1c7-1 13 3 14 9 0 6-4 9-8 12l-9 5-1 1c4 7 0 13-5 15-18 8-35 20-54 23-11 2-21 4-31 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD145",
    d: "M111 199c-27-2-55-6-82-19-9-4-18-11-21-22-2-9 1-18 6-25h1c8 5 17 9 26 10h1a93 93 0 0 1-2-75c7-17 23-23 40-22 14 0 27 4 37 15h1c8-9 19-12 31-14 11-1 22-1 31 7 7 6 10 15 12 24 4 11 5 24 2 36v1l-1-1h-3c-1 1 0 1 1 2 5 5 8 10 10 17v1c-9 2-17 6-24 11h-2c-6-8-15-13-24-17l-2-2 2 1c16 1 28-5 38-16v-2h-2c-10 11-22 17-37 14-6-1-10-4-12-9l-2-1-1 2c1 4 4 6 7 8v1h-1l-9-3c-7-1-11 2-14 11-6 13-16 18-27 18-10 0-19 0-28 5-5 2-8 9-8 13 2 9 6 13 14 14 3 0 6 0 9-2 4-1 7 1 10 3 19 8 37 10 56 1h11l21-2h1c-20 11-42 16-66 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#559B3A",
    d: "M30 101c0 13 2 25 7 37v1h-1c-9-3-17-7-25-13-2-2-2-6-3-9-8-29-5-58 11-85C34 10 63-1 88 8c10 3 18 11 24 20a540 540 0 0 0 7 10v-1c-3-13-12-21-21-28l-1-1h1c18-6 36-8 53 2 17 9 26 23 33 40l1 4-3-2c-11-9-23-10-37-7-10 2-19 5-27 12l-1-1a55 55 0 0 0-71-2c-9 8-12 20-15 31l-1 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB7501",
    d: "M139 168c-17 0-34-2-50-4-8-1-16-1-23 3l-1 2 2 1c10-5 21-4 31-2 31 4 61 5 90-4l6-2c2-1 4-1 6 1 1 2 0 4-1 6-3 5-9 6-14 7-11 3-23 4-35 5-14 0-28-3-42-6-12-1-22-1-33 3-8 2-14-2-16-8s2-12 9-14c11-5 21-4 32-1 14 3 28 3 42 1 9-1 18-1 26-5l28-12 12-3c4 0 7 1 8 5s-1 6-4 8c-11 8-25 12-39 15-11 3-23 4-34 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB7501",
    d: "M126 155c-10 0-17-2-25-3h-1l1-1c10-3 16-10 20-19 3-9 7-10 18-6 12 4 24 10 33 19l2 3-3 1c-16 4-31 5-45 6Zm-10 32a75 75 0 0 1-30-9h1c9-1 19 1 28 2l21 3v1h-1c-5 2-11 3-19 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#030302",
    d: "M101 74c7 0 16 0 23 6 3 2 4 1 6 0 16-10 45-9 58 3 1 1 3 2 1 3-1 1-2 0-3-1-11-8-23-10-37-9-7 1-14 3-20 8-1 1-2 2-1 4l2-2c17-11 43-10 58 3 3 3 5 5 6 9a81 81 0 0 1-56 13c-5-1-10-3-14-6h-1c-7 7-16 9-26 11-18 2-35-4-50-12h-1c18-21 45-30 70-22 4 1 6 3 8 5l1 1v-1c0-4-4-7-10-9-22-4-41 0-59 13l-14 7c-3 1-5 2-4 6 1 3 3 5 7 4 1 0 2 0 2 2 1 1-1 1-2 1-5 1-9-2-10-6-1-5 0-8 6-10 10-3 19-11 29-16 10-3 19-5 31-5Zm-24 58c-10 0-20-3-28-10-1-1-2-2-1-3 1-2 2 0 3 0 13 12 28 13 43 7l12-5c1 0 2-1 3 1 1 1 0 1-1 2-10 5-19 8-31 8Zm46 18-2-2c0-2 1-3 3-3 1 0 2 1 2 3 0 1-1 2-3 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFD",
    d: "M99 82c6 0 11 1 17 3 4 2 7 5 8 9 0 5-2 9-5 11-12 8-24 9-37 8-11-1-21-5-30-9l-1-1c12-13 30-21 48-21Zm51 27c-9 0-17-2-24-6l-1-2c1-1 2-3 1-5 0-2 1-4 3-5 16-12 42-12 56 0h1c5 6 5 6-2 10-11 5-22 8-34 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#030302",
    d: "M86 85c8 0 13 6 13 13s-6 13-13 13a13 13 0 0 1 0-26Zm55 10c0-7 5-12 12-12 6 0 12 5 12 12 0 6-6 12-12 12-7 0-12-6-12-12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h220v202H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPete);
export default __webpack_public_path__ + "static/media/PETE.6a919fe37a999c2c1a63a40a20fdd7a5.svg";
export { ForwardRef as ReactComponent };